import { track, identify, Identify } from '@amplitude/unified'
import type { ValidPropertyType } from '@/services/amplitude/valid-property-type.type'

class TrackingService {
  public trackEvent(
    eventName: string,
    eventProperties?: Record<string, ValidPropertyType>,
    userProperties?: Record<string, ValidPropertyType>,
  ): void {
    if (userProperties) {
      this.patchUserProperties(userProperties)
    }

    track(eventName, eventProperties)

    if (import.meta.env.VITE_MODE === 'local') {
      console.log('[AMPLITUDE] Tracked Event:', {
        eventName: eventName,
        eventProperties: eventProperties,
        userProperties: userProperties,
      })
    }
  }

  public unsetUserProperties(propertyKeys: string[]): void {
    const identifyEvent = new Identify()
    propertyKeys.forEach((key) => identifyEvent.unset(key))
    identify(identifyEvent)
  }

  public setUserProperties(
    userProperties: Record<string, ValidPropertyType>,
  ): void {
    const identifyEvent = new Identify()
    Object.entries(userProperties).forEach(([key, value]) =>
      identifyEvent.set(key as keyof typeof userProperties, value),
    )
    identify(identifyEvent)
  }

  public setOnceUserProperties(
    userProperties: Record<string, ValidPropertyType>,
  ): void {
    const identifyEvent = new Identify()
    Object.entries(userProperties).forEach(([key, value]) =>
      identifyEvent.setOnce(key as keyof typeof userProperties, value),
    )
    identify(identifyEvent)
  }

  private patchUserProperties(
    userProperties: Record<string, ValidPropertyType>,
  ) {
    this.setUserProperties(userProperties)
  }
}

export default new TrackingService()
